/**
 * Форматирует число, добавляя профисные разделители между тысячами
 * @example
 * formatNumber(6000) // "6,000"
 * formatNumber(1234567) // "1,234,567"
 */

export const formatNumber = (value: number | string, locale: string = 'en-US'): string => {
  const num = typeof value === 'string' ? Number(value) : value;
  if (isNaN(num)) return String(value);
  return new Intl.NumberFormat(locale).format(num);
};
